import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import UploadIcon from '@mui/icons-material/Upload';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import CustomizedDialogs from '../components/ModalAlert';
import DemaisArquivosItem from '../components/DemaisArquivosItem';
import { useAuth } from '../hooks/useAuth';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import {
  handleHttpError,
  isFileBig,
  PENDENCIA_FORNECEDOR,
  PENDENCIA_GESTOR,
} from '../utils';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { FormControl } from '@mui/material';

const TIPO_ARQUIVOS_PERMITIDOS = [
  'mp3',
  'mp4',
  'pdf',
  'csv',
  'txt',
  'mov',
  'xls',
  'xlsx',
  'pdf',
  'png',
  'jpeg',
  'jpg',
  'sheet',
  'xml',
];

export const DemaisArquivosPage = ({
  activeStep,
  setActiveStep,
  steps,
  nfs,
  isContract,
  cnpj,
  contratoId,
  contratoDts,
}) => {
  const [file, setFile] = React.useState([]);
  const [isFetchingFiles, setIsFetchingFiles] = React.useState(true);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [filesUploaded, setFilesUploaded] = React.useState([]);
  const [messageError, setMessageError] = React.useState('');
  const [showDialogError, setShowDialogError] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [os, setOs] = React.useState();
  const [ateste, setAteste] = React.useState();
  const { user, isUsuarioSebrae } = useAuth();
  const navigate = useNavigate();
  const params = useParams();
  const snackbar = useSnackbar();
  const theme = useTheme();
  let [searchParams, setSearchParams] = useSearchParams();
  const [checked, setChecked] = React.useState(false);
  const [radioValue, setRadioValue] = React.useState('sim');
  const [justificativa, setJustificativa] = React.useState('');
  const [radioValuePrioritario, setRadioValuePrioritario] = React.useState('');
  const [usersComunicacao, setUsersComunicacao] = React.useState([]);
  const [usersFluig, setUsersFluig] = React.useState([]);
  const [ordensErro, setOrdensErro] = React.useState([]);
  const [isHtml, setIsHtml] = React.useState(false);
  const {
    listarArquivosNotaFiscal,
    enviarArquivosNotaFiscal,
    deletarArquivoDaNotaFiscal,
    listarUsersFluig,
    primeiraOrdem,
    integrarNotaFiscal,
  } = useQuery();
  const { id } = nfs;

  React.useEffect(() => {
    setUsersComunicacao(JSON.parse(process.env.REACT_APP_USERS_SUBCONTRATADA));
    getFirstOrdem();
    getUsersFluig();
    setRadioValuePrioritario(nfs.pagamento_prioritario);
  }, []);

  React.useEffect(() => {
    fetchFiles();
    setFile([]);
  }, [isFetchingFiles]);

  const showFieldJustificativa = [
    PENDENCIA_FORNECEDOR,
    'PENDENCIA DO FORNECEDOR',
    PENDENCIA_GESTOR,
  ].includes(nfs.situacao_nf);

  const fetchFiles = async () => {
    const response = await listarArquivosNotaFiscal(id, 'adicional');
    setFilesUploaded(response.data.data);
  };

  const getFirstOrdem = async () => {
    const response = await primeiraOrdem(id);
    setOs(response.data.data);
  };

  const getUsersFluig = async () => {
    const response = await listarUsersFluig();

    if (response && response.data && response.data.data) {
      let fluigUsers = [];
      response.data.data.map((res) => {
        fluigUsers.push({
          matricula: res.value[0],
          nome: res.value[1],
          login: res.value[2],
        });
      });
      setUsersFluig(fluigUsers);
    }
  };

  const temArquivoSemDescricao = () => {
    return (
      filesUploaded.filter(
        ({ descricao }) => descricao === null || descricao === '',
      ).length > 0
    );
  };

  const sendFile = async (arquivos) => {
    setIsUpdating(true);
    const formData = new FormData();

    arquivos.map((res, i) => {
      formData.append(i + 1, res);
    });

    formData.append('qtn', arquivos.length);
    formData.append('tipo', 'adicional');
    try {
      await enviarArquivosNotaFiscal(id, formData);
      setIsFetchingFiles(!isFetchingFiles);
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setIsUpdating(false);
    }
  };

  React.useEffect(() => {
    if (file && file.length > 0) {
      sendFile(file);
    }
  }, [file]);

  const handleButtonOk = () => {
    setShow(false);

    navigate(`/dashboard/notas/${params.contratoId}`);
  };

  const handleNext = async () => {
    if (temArquivoSemDescricao()) {
      snackbar.showSnackbar('Preencha a descrição dos arquivos');
      return;
    }

    setLoading(true);
    let data = {
      cnpj: nfs.cnpj_prestador_servico.replace(/\D/g, ''),
      nota_id: nfs.id,
      numero_nf: nfs.numero_nf,
    };

    setLoading(true);

    if (isUsuarioSebrae && radioValuePrioritario == undefined) {
      snackbar.showSnackbar(
        'Responda se o pagamento é prioritário antes de prosseguir.',
      );
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      await integrarNotaFiscal({
        nota_id: nfs.id,
        is_prioritario: radioValuePrioritario,
        is_usuario_sebrae: isUsuarioSebrae,
        ateste_matricula: ateste ? ateste.matricula : '',
        ateste_login: ateste ? ateste.login : '',
        ateste_nome: ateste ? ateste.nome : '',
        justificativa,
      });
      setMessage('Nota fiscal enviada com sucesso.');
      setType('success');
      setShow(true);
      setLoading(false);
    } catch (error) {
      setMessage(handleHttpError(error));
      setType('error');
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  const onChangeFile = (event) => {
    const files = [...event.target.files];

    if (files.length > 0) {
      let filesToSend = [];
      files.forEach((file) => {
        const extension = file.name.split('.').pop();

        if (!TIPO_ARQUIVOS_PERMITIDOS.includes(extension.toLowerCase())) {
          snackbar.showSnackbar(
            'Tipo de arquivo inválido. Somente ' +
              TIPO_ARQUIVOS_PERMITIDOS.join(','),
          );
          setFile([]);
          return;
        }

        if (isFileBig(file.size)) {
          snackbar.showSnackbar('Tamanho de arquivo inválido. Máximo é 10MB');
          return;
        }

        filesToSend.push(file);
      });

      setFile(filesToSend);
    }
  };

  const handleCheck = (event) => {
    setChecked(event.target.checked);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onPressDelete = async (fileUploaded, index) => {
    const confirm = await window.confirm('Deseja realmente excluir o arquivo?');

    if (confirm) {
      setIsUpdating(true);
      await deletarArquivoDaNotaFiscal(fileUploaded.id);
      setIsFetchingFiles(!isFetchingFiles);
      setIsUpdating(false);
    }
  };

  const getQuest = () => {
    if (isUsuarioSebrae) {
      if (os.tipo_documento == '5') {
        return (
          <p>
            O responsável pelo ateste{' '}
            <b>
              {os && os.requisitante} - {os && os.nom_requisitante}
            </b>{' '}
            está correto ?
          </p>
        );
      } else {
        if (
          usersComunicacao.includes(os.gestor) ||
          os.tipo_controle == 'Medição' ||
          os.tipo_controle == 'Programação' ||
          os.tipo_controle == 'Ordem'
        ) {
          return (
            <p>
              O responsável pelo ateste{' '}
              <b>
                {os && os.gestor} - {os && os.nom_gestor}
              </b>{' '}
              está correto ?
            </p>
          );
        } else {
          return (
            <p>
              O responsável pelo ateste{' '}
              <b>
                {os && os.requisitante} - {os && os.nom_requisitante}
              </b>{' '}
              está correto ?
            </p>
          );
        }
      }
    } else {
      if (os.tipo_documento == '5') {
        return (
          <p>
            O responsável pelo ateste{' '}
            <b>
              {os && os.requisitante} - {os && os.nom_requisitante}
            </b>
            .
          </p>
        );
      } else {
        if (
          usersComunicacao.includes(os.gestor) ||
          os.tipo_controle == 'Medição' ||
          os.tipo_controle == 'Programação' ||
          os.tipo_controle == 'Ordem'
        ) {
          return (
            <p>
              O responsável pelo ateste{' '}
              <b>
                {os && os.gestor} - {os && os.nom_gestor}
              </b>
              .
            </p>
          );
        } else {
          return (
            <p>
              O responsável pelo ateste{' '}
              <b>
                {os && os.requisitante} - {os && os.nom_requisitante}
              </b>
              .
            </p>
          );
        }
      }
    }
  };

  const changeTipo = (event) => {
    setRadioValue(event);
  };

  const changeTipoPrioritario = (event) => {
    setRadioValuePrioritario(event);
  };

  const clickDetalheModal = () => {
    setMessage(ordensErro && ordensErro.length > 1 && ordensErro[1]);
    setOrdensErro([]);
    setIsHtml(false);
    setType('error');
    setShow(true);
  };

  return (
    <Card
      component="section"
      variant="outlined"
      style={{
        borderTop: `8px solid ${theme.palette.primary.light}`,
        marginTop: '2rem',
      }}
    >
      <CardContent>
        <CustomizedDialogs
          content={messageError}
          btnTxt={'Ok'}
          type="error"
          onClick={() => setShowDialogError(false)}
          handleClose={setShowDialogError}
          visible={showDialogError}
          ordens={ordensErro}
          isHtml={isHtml}
          onClickDetalhe={clickDetalheModal}
        />
        <CustomizedDialogs
          content={message}
          btnTxt={'Ok'}
          type={type}
          onClick={handleButtonOk}
          handleClose={setShow}
          visible={show}
        />
        <Grid style={{ marginTop: 10 }} container spacing={2}>
          <Grid item sm={12}>
            <Typography
              component="h2"
              variant="h6"
              sx={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}
            >
              Importar demais arquivos
            </Typography>
          </Grid>
          <Grid item sm={10}>
            <FormControl fullWidth>
              <TextField
                id="other-files-input"
                disabled
                style={{ width: '100%' }}
                value={(file && file.name) || ''}
                placeholder="Importar arquivos"
                variant="outlined"
                aria-label="Arquivo selecionado"
              />
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <Button
              style={{ width: '100%', height: 40 }}
              variant="contained"
              component="label"
              disabled={temArquivoSemDescricao() ? true : isUpdating}
              aria-label="Selecionar arquivos para importar"
            >
              <UploadIcon />
              Importar
              <input
                onChange={onChangeFile}
                hidden
                multiple
                accept={TIPO_ARQUIVOS_PERMITIDOS.join(',')}
                type="file"
                aria-label="Input de arquivo"
              />
            </Button>
          </Grid>
        </Grid>
        {isUpdating ? <CircularProgress color={'inherit'} size={25} /> : null}
        <br />
        {temArquivoSemDescricao() && (
          <Alert severity="error">
            Adicione a descrição em todos os arquivos para fazer outros uploads
          </Alert>
        )}

        {filesUploaded.map((item, index) => (
          <DemaisArquivosItem
            key={`${index}-demais-arquivos-item`}
            item={item}
            onPressDelete={onPressDelete}
            atualizarLista={fetchFiles}
            isPagamentoDireto={false}
          />
        ))}
        <Grid style={{ marginTop: 10 }} container spacing={2}>
          {isUsuarioSebrae ? (
            <Grid item sm={12}>
              <FormControl component="fieldset" fullWidth>
                <Typography
                  component="legend"
                  variant="body1"
                  sx={{ fontWeight: 'bold', mb: 1 }}
                >
                  O pagamento é prioritário?
                </Typography>
                <RadioGroup
                  row
                  value={radioValuePrioritario}
                  onChange={(e) => {
                    changeTipoPrioritario(e.target.value);
                  }}
                >
                  <FormControlLabel
                    checked={radioValuePrioritario === 'sim'}
                    value="sim"
                    control={<Radio />}
                    label="Sim"
                  />
                  <FormControlLabel
                    checked={radioValuePrioritario === 'nao'}
                    value="nao"
                    control={<Radio />}
                    label="Não"
                  />
                </RadioGroup>
              </FormControl>
              <hr />
            </Grid>
          ) : null}
          {isUsuarioSebrae ? (
            <Grid item sm={12}>
              {os ? getQuest() : null}
              <RadioGroup
                row
                value={radioValue}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={(e) => {
                  changeTipo(e.target.value);
                }}
              >
                <FormControlLabel
                  checked={radioValue === 'sim'}
                  value="sim"
                  control={<Radio />}
                  label="Sim"
                />
                <FormControlLabel
                  checked={radioValue === 'nao'}
                  value="nao"
                  control={<Radio />}
                  label="Não"
                />
              </RadioGroup>
              <hr />
            </Grid>
          ) : null}
          {isUsuarioSebrae && radioValue == 'nao' ? (
            <Grid item sm={12}>
              <p>Selecione o responsável</p>
              <FormControl style={{ width: '100%' }}>
                <Autocomplete
                  disablePortal
                  value={ateste}
                  options={usersFluig}
                  getOptionLabel={(option) =>
                    `${option.login} - ${option.nome}`
                  }
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setAteste(newValue);
                    // setNotaFiscal(notaFiscal);
                  }}
                  fullWidth
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormControl>
            </Grid>
          ) : null}
          {!isUsuarioSebrae ? (
            <Grid item sm={12}>
              {os ? getQuest() : null}
            </Grid>
          ) : null}

          {showFieldJustificativa && (
            <Grid item sm={12}>
              <Typography variant="h6" color="primary">
                Justificativa
              </Typography>

              <textarea
                cols="30"
                rows="5"
                placeholder="Digite sua justificativa"
                value={justificativa}
                onChange={({ target }) => setJustificativa(target.value)}
                style={{
                  resize: 'none',
                  width: '100%',
                  borderRadius: '0.2rem',
                  border: '1px solid #919191',
                }}
              />
            </Grid>
          )}

          <Grid item sm={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleCheck}
                    style={{ padding: '4px' }}
                  />
                }
                label={
                  'Confirma que todos documentos exigidos em contrato/pedido de compra foram enviados?'
                }
              />
            </FormGroup>
            <hr style={{ marginTop: 30 }} />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            justifyContent: 'space-between',
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="warning"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              snackbar.showSnackbar('Rascunho salvo com sucesso.');
              navigate(-1);
            }}
          >
            Salvar como rascunho
            <SaveIcon />
          </Button>
          <Button
            disabled={!checked || temArquivoSemDescricao() || loading}
            onClick={handleNext}
            variant="contained"
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {loading ? (
                <CircularProgress color={'inherit'} size={25} />
              ) : (
                <span>Enviar</span>
              )}
            </Box>
            <ArrowRightAltIcon />
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
